import find from 'lodash/find';

/**
 * Find current flex package line item
 * from an array of line items.
 */
export function getCurrentFlexPackage(packageItems, packageNo) {
  return find(packageItems, function(item) {
    return (item.flex_ind === 'Y' || item.flex_ind === true) && parseInt(item.pkg_no, 10) === packageNo && item.perf_no === null;
  });
}

/**
 * Find current flex package performance line item
 * from an array of line items.
 */
 export function getCurrentFlexPackagePerformance(packageItems, packageNo, performanceNo) {
  return find(packageItems, function(item) {
    return (item.flex_ind === 'Y' || item.flex_ind === true) && parseInt(item.pkg_no, 10) === packageNo && parseInt(item.perf_no, 10) === performanceNo;
  });
}

/**
 * Find current fixed package line item
 * from an array of line items.
 */
export function getCurrentFixedPackage(packageItems, pkgNo) {
  return find(packageItems, function(item) {
    return (item.fixed_seat_ind === 'Y' || item.fixed_seat_ind === true) && parseInt(item.pkg_no, 10) === pkgNo;
  });
}

export function getCurrentFixedPackagePerformance(packageItems) {
  return find(packageItems, function(item) {
    return (item.fixed_seat_ind === 'Y' || item.fixed_seat_ind === true) && parseInt(item.perf_no, 10) === 0;
  });
}

export default {
  getCurrentFlexPackage,
  getCurrentFlexPackagePerformance,
  getCurrentFixedPackage,
  getCurrentFixedPackagePerformance,
};



// WEBPACK FOOTER //
// ./src/javascripts/lib/cart/packages.js